import React, { useState, useCallback, useEffect, useRef } from 'react';
import Tempo from '../Tempo';

import HtmlParser from 'react-html-parser';
import {
  Div,
  Temp,
  City,
  Celcius,
  Desc,
  Widget,
} from "./styled";
const Clima = () => {
  const [clima, setClima] = useState({
    tempo: '',
    dercricao: '',
    local: ''
  });
  const data = useRef({
    dia: '',
    mes: '',
  })
  const key = '316dbaa624107e5740b14e6cbcdb060f';
  const cityID = '3459504';

  useEffect(() => {
    loadClima();
    loadDate();
  }, []);

  const loadClima = () => {
    fetch('https://api.openweathermap.org/data/2.5/weather?id=' + cityID + '&appid=' + key)
      .then((resp) => { return resp.json() })
      .then((data) => {
        drawWeather(data);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const loadMouth = (value) => {
    let mes = '';
    switch (value) {
      case 1:
        mes = 'JAN';
        break;
      case 2:
        mes = 'FEV';
        break;
      case 3:
        mes = 'MAR';
        break;
      case 4:
        mes = 'ABRIL';
        break;
      case 5:
        mes = 'MAI';
        break;
      case 6:
        mes = 'JUN';
        break;
      case 7:
        mes = 'JUL';
        break;
      case 8:
        mes = 'AGO';
        break;
      case 9:
        mes = 'SET';
        break;
      case 10:
        mes = 'OUT';
        break;
      case 11:
        mes = 'NOV';
        break;
      case 12:
        mes = 'DEZ';
        break;
    }
    return mes;
  }

  const loadDate = () => {
    let localTime = new Date();
    let mes = localTime.getMonth() + 1;
    let dia = localTime.getDate();
    data.current['dia'] = dia;
    data.current['mes'] = mes;
  }

  const drawWeather = (d) => {

    var celcius = Math.round(parseFloat(d.main.temp) - 273.15);
    var description = d.weather[0].main;

    setClima({ ...clima, descricao: description, tempo: celcius + '&deg;', local: d.name });
  }

  return (
    <>

      <Widget>
        <div style={{textAlign: "center", width: "100%"}}><h1>Painel de Controle</h1></div>
        <div class="weatherIcon"><span><Tempo /></span></div>
        <div class="weatherInfo">
          <div class="temperature"><span>{HtmlParser(clima.tempo)}</span></div>
          <div class="description">
            <div class="weatherCondition">{clima.descricao}</div>
            <div class="place">JUIZ DE FORA, MG</div>
          </div>
        </div>
        <div class="date">{data.current.dia} {loadMouth(data.current.mes)}</div>
      </Widget>
    </>
  );
}

export default Clima;